import { isFunction } from 'underscore';
import { applyBindings } from 'knockout';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

/**
 * The base class of the viewModels in the page
 * Provide the functionalities including ko-schema hooking-up, common error hanlding logic, etc.
 */
class CommonViewModel {
  configSchema(schema = null, keys = [], model = null, customValidators = {}) {
    koSchema.properties(this, schema, keys, model, customValidators);
  }

  set el(el) {
    this.bindEl(el);
  }

  bindEl(el) {
    applyBindings(this, el);
  }

  showGenericErrors() {
    if (this.errors && isFunction(this.errors.add)) {
      this.errors.add();
    }
  }
}

export default CommonViewModel;
